import React from "react"

import { Center } from "@/styles/CssElement"

const Progress: React.FC<{
    size: number | string
    percentage: number
    style?: React.CSSProperties
    children?: React.ReactNode
}> = ({ style, size = 40, percentage, children }) => {
    return (
        <div
            style={{
                width: size,
                height: size,
                position: "relative"
            }}>
            <div
                style={{
                    width: "100%",
                    height: "100%",
                    position: "relative",
                    borderRadius: "50%",
                    transform: "rotate3d(0, 1, 0, 180deg)",
                    ...style
                }}>
                <svg
                    viewBox="0 0 100 100"
                    style={{ width: size, height: size }}>
                    <path
                        d="
                        M 50,50 m 0,-47
                        a 47,47 0 1 1 0,94
                        a 47,47 0 1 1 0,-94
                    "
                        stroke=""
                        strokeWidth="4"
                        opacity="1"
                        fillOpacity="0"
                        style={{
                            stroke: "#0000001A",
                            strokeDasharray: `${percentage}, 300`,
                            transition: "stroke-dasharray .4s ease"
                        }}></path>
                </svg>
            </div>
            <Center css={{ position: "absolute", width: "100%", height: "100%", inset: 0, cursor: "pointer" }}>
                {children}
            </Center>
        </div>
    )
}

export { Progress }
export default Progress
